import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import LoadingModal from "src/modes/Electric/LoadingModal";
import LockedPricingDefaultRoute from "src/modes/Electric/Routes/LockedPricingDefaultRoute";
import UnlockedPricingDefaultRoute from "src/modes/Electric/Routes/UnlockedPricingDefaultRoute";
import OSModal from "src/components/OSModal";
import ProductAnalytics from "src/components/ProductAnalytics";
import RouteWatcher from "src/components/RouteWatcher";
import { ApplicationStore } from "src/store";
import { isLockedPricingSetup } from "src/store/selectors/account";
import { isVehicleLoading } from "src/store/selectors/vehicles";
import { CONTINUE_DEAL_BASE_PATH } from "src/components/ContinueDeal/constants";
import useSelector from "src/utils/useSelector";

const CustomizePayment = React.lazy(() => import("src/components/CustomizePayment"));
const CreateGarage = React.lazy(() => import("src/components/UserAccount/CreateGarage"));
const MyGarage = React.lazy(() => import("src/components/MyGarage"));
const AccessGarage = React.lazy(() => import("src/components/UserAccount/AccessGarage"));
const UnlockGarage = React.lazy(() => import("src/components/UserAccount/UnlockGarage"));
const ContinueDeal = React.lazy(() => import("src/components/ContinueDeal"));
const Inventory = React.lazy(() => import("src/components/Inventory/Inventory"));

function ElectricModal({
    isAccountLoading,
    isLockedPricing,
    isToggledVehicleLoading,
}: ReturnType<typeof mapStateToProps>) {
    const isAppOpen = useSelector((state) => state.onlineShopper.isAppOpen);

    if (!isAppOpen) {
        return null;
    }

    if (isAccountLoading) {
        return (
            <OSModal>
                <LoadingModal />
            </OSModal>
        );
    }

    return (
        <OSModal>
            <ProductAnalytics>
                <RouteWatcher>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            component={isLockedPricing ? LockedPricingDefaultRoute : UnlockedPricingDefaultRoute}
                        />
                        <Route
                            path="/payment-builder"
                            component={isToggledVehicleLoading ? LoadingModal : CustomizePayment}
                        />
                        <Route path="/my-garage" component={MyGarage} />
                        <Route path="/inventory" component={Inventory} />
                        <Route path="/access-my-garage" component={AccessGarage} />
                        <Route path="/create/:locked?" component={CreateGarage} />
                        <Route path="/unlock-garage" component={UnlockGarage} />
                        <Route path={CONTINUE_DEAL_BASE_PATH} component={ContinueDeal} />
                    </Switch>
                </RouteWatcher>
            </ProductAnalytics>
        </OSModal>
    );
}

function mapStateToProps(state: ApplicationStore) {
    return {
        isAccountLoading: state.account.loading,
        isLockedPricing: isLockedPricingSetup(state),
        isToggledVehicleLoading:
            state.onlineShopper.toggledVin && isVehicleLoading(state, state.onlineShopper.toggledVin),
    };
}
export default connect(mapStateToProps)(ElectricModal);
